import React, { useMemo } from "react";
import { ModalPopup } from "wbm-generic-components";
import { IQuantityLimitItem } from "@wbmason/cart-service/interfaces/quantityLimitItem.js";
import { ICartItem } from "@wbmason/cart-service/interfaces/cartItem.js";
import ConfigProps from "../constants/configProps.js";

export interface IQtyLimitPopupProps {
  configProps: Record<string, string>;
  setShow: boolean;
  qtyLimitItems: IQuantityLimitItem[];
  lastAddedItems: ICartItem[];
  onClose: () => void;
  disableBackdropClick: boolean;
}

export const QtyLimitPopup: React.FC<IQtyLimitPopupProps> = (
  props: IQtyLimitPopupProps
) => {
  const lastAddedItems = useMemo(() => {
    return props.lastAddedItems.map((addToCartItem) => {
      const selectedItem = {
        itemId: addToCartItem.itemIdentifier.id,
        unitId: addToCartItem.itemIdentifier.unitId,
        imageUrl: `${addToCartItem?.brandImage?.imagePathLarge}/${addToCartItem?.brandImage?.imageFileNameLarge}`,
        description: addToCartItem.description,
      };
      const appliedQtyLimitItem = props.qtyLimitItems.find(
        (qtyLimit) =>
          qtyLimit.itemIdentifier.id === selectedItem.itemId &&
          qtyLimit.itemIdentifier.unitId === selectedItem.unitId
      );
      return { selectedItem, appliedQtyLimitItem };
    });
  }, [props.lastAddedItems, props.qtyLimitItems]);

  return (
    <ModalPopup
      header="QUANTITY LIMIT"
      boxShadow
      setShow={props.setShow}
      className="qty-LimitPopup-modal"
      actionItem={props.onClose}
      actionItemText="OK"
      actionItems
      disableBackdropClick={props.disableBackdropClick}
      onClose={props.onClose}
      customZIndex={1500}
    >
      <div>
        <div className="qty-limit-message">
          {props.configProps[ConfigProps.QuantityLimitMessage]}
        </div>
        {lastAddedItems.map((lastAddedItem, index) => {
          return (
            lastAddedItem.appliedQtyLimitItem &&
            lastAddedItem.appliedQtyLimitItem.comment !== "Not Adjusted" && (
              <div
                key={`${lastAddedItem.selectedItem.itemId}_${lastAddedItem.selectedItem.unitId}_${index}`}
              >
                {index > 0 && <hr className="product-border" />}
                <div className="parent-product-box">
                  <div
                    className="product-box col-md-10"
                    key={`product-box-${index}`}
                  >
                    <img
                      src={lastAddedItem.selectedItem.imageUrl}
                      className="product-img"
                    />

                    <div className="row no-gutters">
                      <div className="row no-gutters d-md-flex col-md-8">
                        <div className="applied-qty-limit-item">
                          <div className="qty-adjusted-text">
                            {lastAddedItem.selectedItem.description}
                          </div>
                          <div className="product-itemId">
                            {lastAddedItem.selectedItem.itemId}
                          </div>
                          <div className="qty-limit-quantity">
                            QTY Limit:{" "}
                            {lastAddedItem.appliedQtyLimitItem.quantity}
                          </div>
                          <div className="qty-limit-quantity">
                            Reason: {lastAddedItem.appliedQtyLimitItem.comment}
                          </div>
                        </div>
                      </div>
                      <div className="row no-gutters d-md-flex col-md-1"></div>
                    </div>
                  </div>

                  <div className="row no-gutters adjusted-qty col-mod-2">
                    <div className="applied-qty-limit-item">
                      <div className="qty-adjusted-text">
                        Adjusted QTY:{" "}
                        {lastAddedItem.appliedQtyLimitItem?.qtyAdjusted}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          );
        })}
      </div>
    </ModalPopup>
  );
};

export default QtyLimitPopup;
